import { LifeBuoy, Phone } from "lucide-react";

/**
 * Shown on any screen where patients might reach out in crisis (Messages, ADHD Assistant).
 * Protects the practice legally and meets Apple's guidance for mental-health apps.
 */
export default function CrisisBanner({ className = "" }) {
  return (
    <div
      className={`bg-red-50 border border-red-200 text-red-800 rounded-xl p-3 flex gap-2.5 ${className}`}
      data-testid="crisis-banner"
      role="alert"
    >
      <LifeBuoy className="w-4 h-4 shrink-0 mt-0.5 text-red-600" />
      <div className="text-[12px] leading-snug">
        <p className="font-semibold mb-0.5">This portal is not monitored 24/7.</p>
        <p>
          If you are in crisis, call or text{" "}
          <a href="tel:988" className="underline font-semibold inline-flex items-center gap-0.5" data-testid="crisis-988-link">
            <Phone className="w-3 h-3" /> 988
          </a>{" "}
          (Suicide &amp; Crisis Lifeline), or dial{" "}
          <a href="tel:911" className="underline font-semibold">911</a> for emergencies.
        </p>
      </div>
    </div>
  );
}
